<template>
    <div id="application-wrapper">
        <section class="modal recover-password onboarding">
            <div class="inner">
                <div class="section-header">
                    <i class="back" @click="goStepBack"></i>
                    <span class="title">{{ trans('recover_password') }}</span>
                </div>

                <div class="section-body">
                  <form id="recover__form" data-abide2 data-vv-scope="recoverForm" class="step" @submit.prevent="submitForm">
                          <div class="form-inner">
                            <div class="headline">{{ trans('recover_password') }}</div>
                            <label>
                              <input
                                  v-model="email"
                                  type="email"
                                  name="email"
                                  class="form-control dark"
                                  :placeholder="trans('email')"
                                  :data-vv-as="trans('email')"
                                  v-validate="'required|email'"
                                  :class="{'is-invalid-input': errors.has('recoverForm.email')}"
                                  required>

                              <span class="form-error" v-show="errors.has('recoverForm.email')" :class="{'is-visible': errors.has('recoverForm.email')}">
                                        {{ errors.first('recoverForm.email') }}
                                    </span>
                            </label>

                          </div>
                          <div class="form-footer">
                                <button class="btn btn-rounded btn-primary btn-long" id="btn-recover" type="submit">
                                    {{ trans('recover_now') }}
                                </button>
                                <a href="#" @click="help($event)" class="">Need help?</a>
                          </div>
                        </form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                email: ''
            }
        },
        mixins: [require('@general/lib/mixin').default],
        created() {
            this.email = sessionStorage.getItem('home.loginEmail');
            sessionStorage.removeItem('home.loginEmail');
        },
        methods: {
            help(event) {
              if (typeof zE != "undefined") {
                event.preventDefault()
                zE.activate()
              }else{
                console.log('ZE not exists');
              }
            },
            goStepBack(fallback) {
                window.location.href = window.location.origin
            },
            async submitForm() {
                this.showLoadingButton('#btn-recover')
                let valid = await this.$validator.validateAll('recoverForm')
                if (!valid) {
                    this.restoreLoadingButton('#btn-recover')
                    return
                }

                let response = await axios.post('/api/password/email', {
                    email: this.email,
                    lang: app.lang
                })

                this.restoreLoadingButton('#btn-recover')
                if (response.status === 200) {
                    this.showSuccessNotification(response.data.message)
                }
            }
        }
    }
</script>
